import {
  SECTOR_GET_LIST,
  SECTOR_GET_LIST_SUCCESS,
  SECTOR_GET_LIST_ERROR,
  SECTOR_GET_LIST_WITH_FILTER,
  SECTOR_GET_LIST_WITH_ORDER,
  SECTOR_GET_LIST_SEARCH,
  SECTOR_SELECTED_ITEMS_CHANGE,
  SECTOR_DELETE_ITEM,
  SECTOR_DELETE_ITEM_SUCCESS,
  SECTOR_DELETE_ITEM_ERROR,
} from '../actions';

const INIT_STATE = {
  sectors: [],
  sector: [],
  error: '',
  filter: null,
  searchKeyword: '',
  orderColumn: null,
  loading: false,
  labels: [
    { label: 'EDUCATION', color: 'secondary' },
    { label: 'NEW FRAMEWORK', color: 'primary' },
    { label: 'PERSONAL', color: 'info' },
  ],
  orderColumns: [
    { column: 'id', label: 'Id' },
    { column: 'name', label: 'Name' },
    { column: 'hid', label: 'HST' },
    { column: 'pcc', label: 'PCC' },
    { column: 'note', label: 'Note' },
  ],
  categories: ['Flexbox', 'Sass', 'React'],
  selectedItems: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SECTOR_GET_LIST:
      return { ...state, loading: false };

    case SECTOR_GET_LIST_SUCCESS:
      return { ...state, loading: true, sectors: action.payload, sector: action.payload };

    case SECTOR_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };

    case SECTOR_GET_LIST_WITH_FILTER:
      if (action.payload.column === '' || action.payload.value === '') {
        return { ...state, loading: true, sector: state.sectors, filter: null };
      } else {
        const filteredItems = state.sectors.filter(
          item => item[action.payload.column] === action.payload.value
        );
        return {
          ...state,
          loading: true,
          sector: filteredItems,
          filter: {
            column: action.payload.column,
            value: action.payload.value,
          },
        };
      }

    case SECTOR_GET_LIST_WITH_ORDER:
      if (action.payload === '') {
        return { ...state, loading: true, sector: state.sector, orderColumn: null };
      } else {
        const sortedItems = state.sectors.sort((a, b) => {
          if (a[action.payload] < b[action.payload]) return -1;
          else if (a[action.payload] > b[action.payload]) return 1;
          return 0;
        });
        return {
          ...state,
          loading: true,
          sector: sortedItems,
          orderColumn: state.orderColumns.find(x => x.column === action.payload),
        };
      }

    case SECTOR_GET_LIST_SEARCH:
      if (action.payload === '') {
        return { ...state, sector: state.sectors };
      } else {
        const keyword = action.payload;
        const searchItems = state.sectors.filter(
          item =>
            String(item.id).startsWith(keyword) ||
            String(item.name.toLowerCase()).startsWith(keyword)
        );
        return { ...state, loading: true, sector: searchItems, searchKeyword: action.payload };
      }

    case SECTOR_SELECTED_ITEMS_CHANGE:
      return { ...state, loading: true, selectedItems: action.payload };
    default:
      return { ...state };

    case SECTOR_DELETE_ITEM:
      return { ...state, loading: false };

    case SECTOR_DELETE_ITEM_SUCCESS:
      return { ...state, loading: true, sectors: action.payload, sector: action.payload };

    case SECTOR_DELETE_ITEM_ERROR:
      return { ...state, loading: true, error: action.payload };
  }
};
